// extracted by mini-css-extract-plugin
module.exports = {"themedArticlePage":"ThemedArticlePage_themedArticlePage__0KcZw","content":"ThemedArticlePage_content__QxyJV"};